import React from 'react';
import _ from 'lodash';
import clsx from "clsx";

import { Grid } from '@material-ui/core';

import PrimaryButton from '../../../../components/Buttons/PrimaryButton';
import useStyles from './styles';
import CustomersNew from '../../../../components/CustomersSelectorProviderNew/CustomersNew';
import CustomersList from '../../../../components/CustomersSelectorProviderNew/components/CustomersList';
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";

function CustomersSelectionModal({ open, onClose, onSelect, selectedCustomersIds, title, singleSelection, confirmText, modalLoading }) {

  const [selectedCustomers, setSelectedCustomers] = React.useState([]);

  React.useEffect(() => {
    setSelectedCustomers((current) =>
      _.filter(current, (customer) => selectedCustomersIds.includes(customer.customer_id)));

  }, [JSON.stringify(selectedCustomersIds || [])])

  const handleConfirm = () => {
    onSelect(selectedCustomers);
  };

  return (
    <BaseDialog
      title={title}
      handleClose={onClose}
      open={open}
      onClose={onClose}
      modalLoading={modalLoading}
      actions={
        <CustomerSelectionActions
          singleSelection={singleSelection}
          selectedCustomers={selectedCustomers}
          confirmText={confirmText}
          handleConfirm={handleConfirm}
        />
      }
    >
      <CustomerSelectionContent
        singleSelection={singleSelection}
        selectedCustomers={selectedCustomers}
        setSelectedCustomers={setSelectedCustomers}
      />
    </BaseDialog>
  );
}

CustomersSelectionModal.defaultProps = {
  title: 'Kunden für das Anschreiben auswählen',
  singleSelection: false,
  confirmText: 'Speichern & fortfahren',
  modalLoading: false
};

export default CustomersSelectionModal;

export const CustomerSelectionActions = (props) => {
  const {
    singleSelection,
    selectedCustomers,
    confirmText,
    handleConfirm
  } = props;

  return (
    <Grid container spacing={2} direction={'column'} alignContent={'flex-end'}>
      <Grid item>
        <PrimaryButton
          text={!singleSelection && _.isEmpty(selectedCustomers) ? 'Ohne Kunden fortfahren' : confirmText}
          onButtonClick={handleConfirm}
          disabled={singleSelection && selectedCustomers.length === 0}
        />
      </Grid>
    </Grid>
  )
}

export const CustomerSelectionContent = (props) => {
  const {
    singleSelection,
    selectedCustomers,
    setSelectedCustomers,
  } = props;

  const classes = useStyles();

  const addExtraColumns = [{
    content: [{
      header: '',
      body: {
        content: (customer) => {

          const classes = useStyles();

          const addCustomer = () => {
            setSelectedCustomers((customers) => ([...customers, customer]));
          };

          return (
            <PrimaryButton
              text={<i className={'far fa-plus'} />}
              onButtonClick={addCustomer}
              color={'success'}
              disabled={singleSelection && selectedCustomers.length === 1}
              customClasses={{root: clsx(classes.buttonRoot, classes.buttonRootAdd)}}
            />
          )
        },
        className: 'extraButton',
      }
    }]
  }];

  const removeExtraColumns = [{
    content: [{
      header: '',
      body: {
        content: (customer) => {

          const classes = useStyles()
          const removeCustomer = () => {
            setSelectedCustomers((customers) => ([...customers].filter((c) => c.customer_id !== customer.customer_id)));
          };

          return (
            <PrimaryButton
              text={<i className={'far fa-minus'} />}
              onButtonClick={removeCustomer}
              color={'success'}
              customClasses={{root: clsx(classes.buttonRoot, classes.buttonRootRemove)}}
            />
          )
        },
        className: 'extraButton',
      }
    }]
  }];

  return (
    <div className={classes.dialogContentRoot }>
      <div>
        <CustomersList
          customers={selectedCustomers}
          extraColumns={removeExtraColumns}
        />
      </div>

      <CustomersNew
        extraColumns={addExtraColumns}
        withHeader={false}
        excludedCustomersIDs={selectedCustomers.map((c) => c.customer_id)}
      />
    </div>
  )
}
